// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1BLQM","bigColWidth":"Table_bigColWidth__18COY","biggerColWidth":"Table_biggerColWidth__3ZQWl","row":"Table_row__21kYg","col":"Table_col__3hLGj"};